<template>
  <div>
    <Modal
      ref="modal"
      title="Delete template"
      body="Are you sure you want to delete this template? Deleting a template is a permanent action. We cannot restore this template after deletion."
      action="Delete"
      action-color="red"
      @close-modal="handleCancel"
      @handle-action="deleteEmailTemplate"
    />
  </div>
</template>

<script>
import Modal from '../../shared/Modal.vue';
import { toast } from 'vue-sonner';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    Modal,
  },
  props: ['selectedTemplateId'],
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  methods: {
    deleteEmailTemplate() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      fetch(`/api/email_templates/${self.selectedTemplateId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => response.json())
        .then(data => {
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (data.status != 'error') {
            toast.success('Email template deleted', {
              action: { label: 'Dismiss' },
              description: 'Your email template was successfully deleted.  Use the button below to dismiss this alert.',
            });
            self.$emit('handleSaveSettings');
          } else {
            toast.error('Email template deletion error', {
              action: { label: 'Dismiss' },
              description: data.message,
            });

            if (data.message.includes('dependent workflow_action_emails')) self.$emit('handle-in-use');
          }
        });
    },
    handleCancel() {
      this.$emit('handleTemplateDeleteCancel');
    },
  },
};
</script>
